var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeliveries = function SvgDeliveries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.547 8.388 14.001 14.49 3.454 8.388c.467-.863 1.143-1.621 1.902-2.041l6.23-3.454c1.33-.746 3.5-.746 4.83 0l6.23 3.454c.758.42 1.435 1.178 1.901 2.041Z",
    fill: "#F35508"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14 14.49v11.177c-.874 0-1.75-.187-2.414-.56l-6.23-3.454c-1.412-.781-2.567-2.741-2.567-4.351v-6.604c0-.746.257-1.563.665-2.31l10.547 6.102Z",
    fill: "#F35508"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.212 10.698v6.604c0 1.61-1.155 3.57-2.566 4.351l-6.23 3.454c-.665.373-1.54.56-2.415.56V14.49l10.546-6.102c.409.747.665 1.564.665 2.31Z",
    fill: "#F35508"
  })));
};
export default SvgDeliveries;